/**
 * Profile Service
 * Handles all user profile-related API calls
 */

import { apiGet, apiPut } from './apiClient';
import API_CONFIG from './apiConfig';

/**
 * Get current user's profile information
 * @returns {Promise}
 */
export const getProfile = async () => {
  return apiGet(API_CONFIG.endpoints.profile);
};

/**
 * Update user profile information
 * @param {Object} data - { name?: string, gender?: string, ... }
 * @returns {Promise}
 */
export const updateProfile = async (data) => {
  return apiPut(API_CONFIG.endpoints.profile, data);
};

/**
 * Change user password
 * @param {Object} data - { currentPassword: string, newPassword: string }
 * @returns {Promise}
 */
export const changePassword = async (data) => {
  return apiPut(API_CONFIG.endpoints.changePassword, data);
};

